var initObj = ['comment','footprint','photoSub'];

export function lsSearchDisplayInit() {
  localStorage.setItem('SearchDisplay', initObj.join(','));
}
